<template>
  <validation-observer ref="simpleRules">
    <user-type-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import UserTypeForm from '@/views/User_types/UserTypeForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Edit',
  components: {
    UserTypeForm,
    SaveButton,
    ValidationObserver,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['userTypes/dataItem']
    },
    saveData() {
      return this.$store.getters['userTypes/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      this.submitStatus = false
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('userTypes/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('userTypes/saveData', this.dataItem)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'),
            icon: 'XIcon',
            text: this.$t('common.requiredFields'),
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
